import React, { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody, Table, Badge, Button } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { getOperatorUsers } from "../../slices/operators/thunk";
import { formatDateDDMMYYYY } from "../../helpers/dateUtils";

const OperatorUsersModal = ({ isOpen, toggle, operator }) => {
    const dispatch = useDispatch();
    const { currentOperatorUsers } = useSelector((state) => state.Operators);
    const { users, loading, totalUsers } = currentOperatorUsers;

    useEffect(() => {
        if (isOpen && operator && operator._id) {
            dispatch(getOperatorUsers(operator._id));
        }
    }, [isOpen, operator, dispatch]);

    const columns = [
        { name: "User ID", selector: user => user._id },
        { name: "Account No.", selector: user => user.acnumber },
        { name: "Created At", selector: user => formatDateDDMMYYYY(user.createdAt) }
    ];

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg" scrollable>
            <ModalHeader toggle={toggle}>
                Users for Operator: {operator?.username}
                <Badge color="info" className="ms-2">Total: {totalUsers || 0}</Badge>
            </ModalHeader>
            <ModalBody>
                {loading ? (
                    <div className="text-center py-4">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                ) : (
                    <div className="table-responsive">
                        <Table className="table-hover table-striped align-middle table-nowrap mb-0">
                            <thead className="table-light">
                                <tr>
                                    {columns.map((col, index) => (
                                        <th key={index}>{col.name}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {users && users.length > 0 ? (
                                    users.map((user, index) => (
                                        <tr key={index}>
                                            <td>{user._id ? <span title={user._id}>{user._id}</span> : "N/A"}</td>
                                            <td>{user.acnumber}</td>
                                            <td>{formatDateDDMMYYYY(user.createdAt)}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={columns.length} className="text-center">
                                            No users found for this operator
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </div>
                )}
            </ModalBody>
            <div className="modal-footer">
                <Button color="secondary" onClick={toggle}>Close</Button>
            </div>
        </Modal>
    );
};

export default OperatorUsersModal;
